import classNames from 'classnames';
import React, { FC } from 'react';
import Dropzone from 'react-dropzone';
import { FormattedMessage } from 'react-intl';
import { Hyperlink } from '../../../../../components/Hyperlink';
import { doctrineAnalytics } from '../../../../../utils/analyticsUtils';
import {
  DecisionUploadFormLabel,
  DecisionUploadFormError,
} from '../components/DecisionUploadFormComponents';
import styles from './decision_upload_file_field.module.scss';
import { MaterialIcon } from '../../../../../components/material-icon/MaterialIcon';

type Props = {
  value: File | undefined;
  hasError: boolean;
  handleFileDrop: (
    accepted: File[],
    rejected: File[],
    event: React.DragEvent<HTMLDivElement>,
  ) => void;
  resetFile: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

export const DecisionUploadFileField: FC<Props> = ({
  value,
  hasError,
  handleFileDrop,
  resetFile,
}) => {
  return (
    <>
      <DecisionUploadFormLabel htmlFor="upload-dropzone">
        <FormattedMessage id="upload/decision-upload/components/DecisionUploadFileField.tsx/1" />
      </DecisionUploadFormLabel>
      {!value && (
        <Dropzone
          maxSize={100000000}
          multiple={false}
          onDrop={handleFileDrop}
          accept={['.pdf']}
        >
          {({ getRootProps, getInputProps }) => (
            <div
              {...getRootProps()}
              id="upload-dropzone"
              className={classNames(
                styles.block,
                hasError && 'is-invalid-input',
              )}
            >
              <input name="file" {...getInputProps()} />
              <div className={styles.text}>
                <MaterialIcon name="file_upload" />
                <p>
                  <FormattedMessage id="upload/decision-upload/components/DecisionUploadFileField.tsx/2" />
                </p>
                <p>
                  <FormattedMessage id="upload/decision-upload/components/DecisionUploadFileField.tsx/3" />
                </p>
                <button
                  className={styles.chooseButton}
                  type="button"
                  onClick={() => {
                    doctrineAnalytics('Upload ButtonChooseClicked');
                  }}
                >
                  <FormattedMessage id="upload/decision-upload/components/DecisionUploadFileField.tsx/4" />
                </button>
              </div>
            </div>
          )}
        </Dropzone>
      )}
      {value && (
        <div className="input-group">
          <input
            disabled
            className="input-group-field"
            type="text"
            value={value.name}
          />
          <div className="input-group-button">
            <button type="button" onClick={resetFile}>
              <FormattedMessage id="upload/decision-upload/components/DecisionUploadFileField.tsx/5" />
            </button>
          </div>
        </div>
      )}
      <div className={styles.info}>
        <FormattedMessage id="upload/decision-upload/components/DecisionUploadFileField.tsx/6" />
      </div>
      <div className={styles.info}>
        <FormattedMessage id="upload/decision-upload/components/DecisionUploadFileField.tsx/7" />{' '}
        <Hyperlink
          href="https://doctrine.wetransfer.com"
          className={styles.infoLink}
        >
          <FormattedMessage id="upload/decision-upload/components/DecisionUploadFileField.tsx/8" />
        </Hyperlink>
        <FormattedMessage id="upload/decision-upload/components/DecisionUploadFileField.tsx/9" />
      </div>
      {hasError && (
        <DecisionUploadFormError>
          <FormattedMessage id="upload/decision-upload/components/DecisionUploadFileField.tsx/10" />
        </DecisionUploadFormError>
      )}
    </>
  );
};
